"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "PasswordStrengthBar__Wrapper",
  componentId: "sc-1eq0jgx-0"
})(["width:200px;"]);
const ProgressContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "PasswordStrengthBar__ProgressContainer",
  componentId: "sc-1eq0jgx-1"
})(["border-radius:", ";background:", ";box-shadow:", ";"], ({
  theme
}) => theme.orbit.borderRadiusBadge, ({
  theme
}) => theme.orbit.backgroundBody, ({
  theme
}) => `inset 0 1px 2px ${theme.orbit.backgroundBody}, 0 1px ${theme.orbit.paletteCloudNormal}`);
const ProgressBar = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "PasswordStrengthBar__ProgressBar",
  componentId: "sc-1eq0jgx-2"
})(["height:", ";border-radius:", ";background-color:", ";width:", ";transition:width 0.5s;"], ({
  theme
}) => theme.orbit.spaceXXSmall, ({
  theme
}) => theme.orbit.borderRadiusBadge, ({
  color
}) => color, ({
  width
}) => width);
const PasswordStrengthBar = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBar, {
        "data-test": "MagicLogin-PasswordStrengthBar",
        ...props
      })
    })
  });
};
var _default = PasswordStrengthBar;
exports.default = _default;